interface Props {
  selected: number;
  steps: { name: string; id: number }[];
  onChange: (selected: number) => void;
}

const Tabs = (props: Props) => {
  const { selected, onChange, steps } = props;

  return (
    // <div className="tabs flex items-center justify-center">
    //   {steps.map((step, index: number) => (
    //     <>
    //       <div
    //         key={step.id}
    //         className={`cursor-pointer flex-shrink-0 tab items-center flex flex-col ${selected >= step.id ? "active" : ""}`}
    //         onClick={() => onChange(step.id)}
    //       >
    //         <div>
    //           {selected >= step.id ? (
    //             <div
    //               className={`rounded-full h-4 w-4 border-8 p-[7px] bg-white border-[#1c1c2c] ${selected >= step.id ? "" : "opacity-50"}`}
    //             ></div>
    //           ) : (
    //             <div
    //               style={{
    //                 width: "32px",
    //                 height: "32px",
    //                 border: "1px solid #c09bef",
    //                 borderRadius: "50%",
    //                 display: "flex",
    //                 alignItems: "center",
    //                 justifyContent: "center",
    //               }}
    //             >
    //               <span
    //                 style={{
    //                   height: "16px",
    //                   width: "16px",
    //                   display: "block",
    //                   borderRadius: "50%",
    //                   background: "#c09bef",
    //                 }}
    //               ></span>
    //             </div>
    //           )}
    //         </div>
    //         <div>
    //           <div
    //             className={`${selected >= step.id ? "text-[#1c1c2c]" : "text-[#1B1C1E]"} text-base`}
    //           >
    //             {step.name}
    //           </div>
    //         </div>
    //       </div>
    //       {index !== steps.length - 1 && (
    //         <span
    //           className={`w-full h-[2px] ${selected > step.id ? "bg-[#8346d48e]" : "bg-[#9358e031]"}`}
    //         ></span>
    //       )}
    //     </>
    //   ))}
    // </div>

    <div className="wrapper option-1 option-1-1">
      <ol className="c-stepper">
        {steps.map((step, index) => (
          <li
            key={index}
            className={`justify-center items-center c-stepper__item cursor-pointer ${
              selected === step.id ? "active" : ""
            }`}
            onClick={() => onChange(step.id)}
          >
            <div
              className={`rounded-full -mt-[46px] h-4 w-4 border-8 p-[7px] bg-white border-[#1c1c2c] ${selected >= step.id ? "" : "opacity-50"}`}
            ></div>
            <span
              className={`c-stepper__title  ${selected >= step.id ? "text-[#1c1c2c]" : ""}`}
            >
              {step.name}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Tabs;
